// extracted by mini-css-extract-plugin
export default {"containerFlex":"SportsNews_containerFlex__Z4VTt"};